'use client'

import type { MouseEvent } from 'react'

import { Button } from '@/frontend/design-system/actions/Button'

function handleClick(event: MouseEvent<HTMLButtonElement>) {
  event.preventDefault()

  // TODO: Replace querySelector with a ref-based scroll
  const contactForm = document.querySelector('#contact-form')

  if (contactForm) {
    contactForm.scrollIntoView({ behavior: 'smooth' })
  }
}

export function ScrollToContactButton() {
  return (
    <Button marketing onClick={handleClick}>
      Napisz do mnie
    </Button>
  )
}
